import createEscaper from './_createEscaper.js';
import escapeMap from './_escapeMap.js'; // Function for escaping strings to HTML interpolation.

export default createEscaper(escapeMap);